import { UserPermissions } from '../../model/auth.model'
import { UserRoles } from './../../../admin/model/admin.model'
import {
  BlobResponse,
  CarrierResponse,
  CreditReinsurer,
  FeatureFlag,
  StudyResponse,
} from '../../../api/model/backend.model'

export interface State {
  username: string | null
  name: string | null
  authenticated: boolean
  redirectURL: string | null
  analyzeReToken: string | null
  marketToken: string | null
  userPermissions: UserPermissions | null
  security: string[] | null
  blobs: {
    thumbnail?: BlobResponse
    carrier?: BlobResponse
    reinsurer?: BlobResponse
    market?: BlobResponse
  }
  carriers: CarrierResponse[] | null
  studies: StudyResponse[] | null
  userPermissionsError: string | null
  token: string | null
  selectedApp: string | null
  authenticatingUser: string | null
  sageLogicalRole: UserRoles
  featureFlags: FeatureFlag[] | null
  sharedLimits: any[] | null
  sharedLimitMembers: any[] | null
  compareViews: any[] | null
  hasWhitespaceAccess: boolean | null
  usaBasedUser: boolean | null
  facSageUrl: string | null
  salesforceUserRole: string | null
  creditReinsurer: CreditReinsurer | null
  roles: string[]
  allowedRoles: string[]
}

export const initialState: State = {
  username: null,
  name: null,
  authenticated: false,
  redirectURL: null,
  analyzeReToken: null,
  marketToken: null,
  userPermissions: null,
  security: null,
  blobs: {},
  carriers: null,
  studies: null,
  userPermissionsError: null,
  token: null,
  selectedApp: null,
  authenticatingUser: null,
  sageLogicalRole: null,
  featureFlags: null,
  sharedLimits: null,
  sharedLimitMembers: null,
  compareViews: null,
  hasWhitespaceAccess: false,
  usaBasedUser: null,
  facSageUrl: null,
  salesforceUserRole: null,
  creditReinsurer: null,
  roles: [],
  allowedRoles: [],
}
